import type { ChatbotMetric, StatusTone } from '../../../types/chatbot-message.types';

import { MetricRow } from './metric-row';
import { StatusBadge } from './status-badge';

interface StatusCardProps {
  tone: StatusTone;
  badge: string;
  title: string;
  body?: string | undefined;
  metrics?: ChatbotMetric[] | undefined;
}

/** Card with a tone-colored badge + headline + optional body paragraph + optional metric table. */
export function StatusCard({ tone, badge, title, body, metrics }: StatusCardProps) {
  return (
    <div className="bg-muted/40 space-y-2 rounded-xl p-3">
      <StatusBadge tone={tone}>{badge}</StatusBadge>
      <p className="text-sm font-semibold">{title}</p>
      {body ? <p className="text-muted-foreground text-xs leading-5">{body}</p> : null}
      {metrics && metrics.length > 0 ? (
        <div className="space-y-1.5 pt-1">
          {metrics.map((metric, idx) => (
            <MetricRow key={`${metric.label}-${String(idx)}`} {...metric} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
